import { TOGGLE_DOMAIN_CHANGE_MODAL } from './actions';

const domainChangeModal = (state = false, action) => {
  switch (action.type) {
    case TOGGLE_DOMAIN_CHANGE_MODAL:
      return !state;

    default:
      return state;
  }
};

export default domainChangeModal;
